export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null
  },
  actions: {
    success ({commit}, message) {
      commit('success', message)
    },
    error ({commit}, message) {
      commit('error', message)
    },
    clear ({commit}, message) {
      commit('clear', message)
    }
  },
  mutations: {
    success (state, message) {
      state.type = 'success'
      state.message = message
      setTimeout(function () {
        state.type = null
        state.message = null
      }, 5000)
    },
    error (state, message) {
      state.type = 'error'
      state.message = message
      setTimeout(function () {
        state.type = null
        state.message = null
      }, 5000)
    },
    clear (state) {
      state.type = null
      state.message = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/_store/alert.js